module.exports = __webpack_public_path__ + "media/images/memes/pointing-up-2cd4d12698c8f4bd29527cb7f7790c1b.gif";